<template>
    <div class="full-screen-loader">
        <div class="spinner-border" role="status">
            <span class="sr-only">Loading...</span>
        </div>
    </div>
</template>

<script>
export default {
    name: 'FullScreenLoader',
}

</script>

<style lang="scss" scoped></style>